var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TW2"},[_c('div',{staticClass:"TW2_left"},[_c('img',{staticClass:"TW2_left_image",style:(_vm.TW1_right_image_style),attrs:{"src":_vm.imgUrl,"alt":"图片"}})]),_c('div',{staticClass:"TW2_right"},[_c('pre',[_vm._v("      "),_c('div',{staticClass:"TW2_right_div",domProps:{"innerHTML":_vm._s(this.text)}}),_vm._v("\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }